import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_pricing_scheme_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  ref_hdr_table: fromDatatype.VarcharDatatypeInterface;
  ref_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ref_line_table: fromDatatype.VarcharDatatypeInterface;
  ref_line_guid: fromDatatype.GuidDataFieldInterface;
  ref_ext_table: fromDatatype.VarcharDatatypeInterface;
  ref_ext_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  id_device: fromDatatype.GuidDataFieldInterface;
  id_user: fromDatatype.GuidDataFieldInterface;
  id_user_agent: fromDatatype.GuidDataFieldInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
}

export class bl_fi_mst_pricing_scheme_event_RowClass implements bl_fi_mst_pricing_scheme_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  ref_hdr_table: fromDatatype.VarcharDatatypeInterface;
  ref_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ref_line_table: fromDatatype.VarcharDatatypeInterface;
  ref_line_guid: fromDatatype.GuidDataFieldInterface;
  ref_ext_table: fromDatatype.VarcharDatatypeInterface;
  ref_ext_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  id_device: fromDatatype.GuidDataFieldInterface;
  id_user: fromDatatype.GuidDataFieldInterface;
  id_user_agent: fromDatatype.GuidDataFieldInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
}


